import { useState, useEffect } from "react";
import { Checkbox } from "antd";
import {
  faVenus,
  faMars,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./GenderFilter.scss";
import { BaseFilterProps } from "interfaces/filter-component-base";

const GenderFilter = (props: BaseFilterProps) => {
  const { onChangeValues, values } = props;
  const [selectedGenders, setSelectedGenders] = useState<string[]>([]);
  useEffect(() => {
    if (values && Array.isArray(values)) {
      setSelectedGenders(values);
    } else if (values && typeof values === "string") {
      setSelectedGenders(values.split(";"));
    } else {
      setSelectedGenders([]);
    }
  }, [values]);

  const handleGenderChange = (gender: "female" | "male" | "nonBinary") => {
    const newGenders = selectedGenders.includes(gender)
      ? selectedGenders.filter((g) => g !== gender)
      : [...selectedGenders, gender];

    const uniqueGenders = Array.from(new Set(newGenders));
    setSelectedGenders(uniqueGenders);

    if (onChangeValues) {
      onChangeValues(uniqueGenders.join(";"));
    }
  };

  return (
    <div className="gender-checkbox-items">
      <label className="gender-checkbox-item">
        <div className="gender-checkbox-icon female">
          <FontAwesomeIcon icon={faVenus} />
        </div>
        <div className="gender-checkbox-content">
          <p className="gender-checkbox-content-title">Female</p>
          <p className="gender-checkbox-content-description">Female creators</p>
        </div>
        <div className="gender-checkbox">
          <Checkbox
            checked={selectedGenders.includes("female")}
            onChange={() => handleGenderChange("female")}
          />
        </div>
      </label>
      <label className="gender-checkbox-item">
        <div className="gender-checkbox-icon male">
          <FontAwesomeIcon icon={faMars} />
        </div>
        <div className="gender-checkbox-content">
          <p className="gender-checkbox-content-title">Male</p>
          <p className="gender-checkbox-content-description">Male creators</p>
        </div>
        <div className="gender-checkbox">
          <Checkbox
            checked={selectedGenders.includes("male")}
            onChange={() => handleGenderChange("male")}
          />
        </div>
      </label>
      <label className="gender-checkbox-item">
        <div className="gender-checkbox-icon other">
          <FontAwesomeIcon icon={faCircleNotch} />
        </div>
        <div className="gender-checkbox-content">
          <p className="gender-checkbox-content-title">Other</p>
          <p className="gender-checkbox-content-description">
            Non-binary & other
          </p>
        </div>
        <div className="gender-checkbox">
          <Checkbox
            checked={selectedGenders.includes("nonBinary")}
            onChange={() => handleGenderChange("nonBinary")}
          />
        </div>
      </label>
    </div>
  );
};

export default GenderFilter;
